import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang'

Vue.use(VueRouter)

/* Layout */
import Layout from '@/layout'
import fleetLogin from '@/views/login.vue'
import personalLogin from '@/tbbaccess/views/login.vue'

export const constantRoutes = [
  {
    path: '/login',
    component: process.env.VUE_APP_PREFIX === 'tbbaccess' ? personalLogin : fleetLogin,
    hidden: true
  },
  {
    path: '/register',
    component: (resolve) => require(['@/views/register'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/share',
    component: (resolve) => require(['@/views/share'], resolve),
    hidden: true
  },
  {
    path: '/share/detail/page',
    component: (resolve) => require(['@/views/share/detail'], resolve),
    name: 'ShareDetail',
    meta: { title: i18n.t('menu.detail') },
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/users/account/index',
    name: 'Home',
    hidden: true,
    meta: { title: i18n.t('menu.home') },
    children: [
      {
        path: '/home',
        component: (resolve) =>
          require(['@/views/users/account/index'], resolve),
        name: 'Home',
        meta: { title: i18n.t('menu.home') }
      },
      {
        path: '/home/alarm/page',
        component: (resolve) => require(['@/views/home/alarm'], resolve),
        name: 'Alarm',
        meta: { title: i18n.t('menu.alarm') },
        hidden: true
      },
      {
        path: '/home/detail/page',
        component: (resolve) => require(['@/views/home/detail'], resolve),
        name: 'HomeDetail',
        meta: { title: i18n.t('menu.detail') },
        hidden: true
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/vehicles/subdetail/page',
        component: (resolve) => require(['@/views/vehicles/detail'], resolve),
        name: 'VehiclesDetail',
        meta: { title: i18n.t('menu.detail') }
      },
      {
        path: '/vehicles/airconditioner/page',
        component: (resolve) =>
          require(['@/views/vehicles/detail/airconditioner'], resolve),
        name: 'AirConditioner',
        meta: { title: i18n.t('menu.airconditioner') }
      },
      {
        path: '/vehicles/groupLog/log',
        component: (resolve) => require(['@/views/vehicles/groupLog'], resolve),
        name: 'groupLog',
        meta: { title: i18n.t('menu.group_log') }
      },
      {
        path: '/vehicles/groupLog/logDetail',
        component: (resolve) =>
          require(['@/views/vehicles/groupLogDetail'], resolve),
        name: 'groupLogDetail',
        meta: { title: i18n.t('menu.group_log') }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/data/report/page',
        component: (resolve) =>
          require(['@/views/data/reports/DefaultReport'], resolve),
        name: 'DefaultReport',
        meta: { title: i18n.t('menu.default_report') }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/other/issueReportDetail/page',
        component: (resolve) =>
          require(['@/views/other/issueReportDetail/index'], resolve),
        name: 'issueReportDetail',
        meta: { title: i18n.t('menu.default_issue_report') }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/role/alocation/page',
        component: (resolve) =>
          require(['@/views/users/role/AllocationRole'], resolve),
        name: 'AllocationRole',
        meta: { title: i18n.t('menu.current_role') }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    path: '/setting/set',
    children: [
      {
        path: '/setting/set',
        component: (resolve) => require(['@/views/setting.vue'], resolve),
        name: 'Settings',
        meta: { title: i18n.t('menu.setting'), allowBack: false }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/testView',
        component: (resolve) => require(['@/views/testView.vue'], resolve),
        name: 'testView',
        meta: { title: i18n.t('menu.setting'), allowBack: false }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/prealarm/prefleet/page',
        component: (resolve) =>
          require(['@/views/data/prealarm/Prefleet'], resolve),
        name: 'Prefleet',
        meta: { title: i18n.t('menu.prealarm_fleet') }
      },
      {
        path: '/prealarm/presubfleet/page',
        component: (resolve) =>
          require(['@/views/data/prealarm/PreSubfleet'], resolve),
        name: 'PreSubfleet',
        meta: { title: i18n.t('menu.prealarm_sub_fleet') }
      }
    ]
  },
  //显示的菜单
  {
    path: '',
    component: Layout,
    "name": "Manage",
    "path": "/users",
    "meta": {
      "title": "Manage",
      "icon": " ",
      "noCache": true
    },
    children: [
      {
        path: "/users/account/index",
        component: (resolve) =>
          require(['@/views/users/account/index'], resolve),
        name: 'Account',
        meta: {
          title: 'Account',
          "icon": "accout",
          "noCache": true
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    "name": "Device",
    "path": "/devices",
    "meta": {
      "title": "Device",
      "icon": " ",
      "noCache": true
    },
    children: [
      {
        path: "/device/public-group/index",
        component: (resolve) =>
          require(['@/views/device/public-group/index'], resolve),
        name: 'Public Group',
        "meta": {
          "title": "Public Group",
          "icon": "public-group",
          "noCache": true
        },
      },
      {
        path: "/device/agent/index",
        component: (resolve) =>
          require(['@/views/device/agent/index'], resolve),
        name: 'Agent',
        "meta": {
          "title": "Agent",
          "icon": "agent",
          "noCache": true
        },
      },
      {
        path: "/device/territory/index",
        component: (resolve) =>
          require(['@/views/device/territory/index'], resolve),
        name: 'Territory',
        "meta": {
          "title": "Territory",
          "icon": "territory",
          "noCache": true
        },
      },
      {
        path: "/device/sn-list/index",
        component: (resolve) =>
          require(['@/views/device/sn-list/index'], resolve),
        name: 'SN List',
        "meta": {
          "title": "SN List",
          "icon": "sn-list",
          "noCache": true
        },
      },
      {
        path: "/device/public-group/association",
        hidden: true,
        component: (resolve) =>
          require(['@/views/device/association/index'], resolve),
        name: 'Association Configuration',
        "meta": {
          "title": "Association Configuration",
          "icon": "association",
          "noCache": true
        },
      },
    ]
  },
  {
    path: '',
    component: Layout,
    "name": "Service Center",
    "path": "/other",
    "meta": {
      "title": "Service Center",
      "icon": "issue_list",
      "noCache": true
    },
    children: [
      {
        path: "/other/feedbacklist",
        component: (resolve) =>
          require(['@/views/other/feedbacklist/index'], resolve),
        name: 'Issue List',
        meta: {
          title: 'Issue List',
          "icon": "issue_list",
          "noCache": true
        }
      },
      {
        path: "/other/issueReport",
        component: (resolve) =>
          require(['@/views/other/issueReportList/index'], resolve),
        name: 'Issue Report',
        meta: {
          title: 'Issue Report',
          "icon": "issue_report",
          "noCache": true
        }
      },
      {
        path: '/other/feedbackDetail/page',
        hidden: true,
        component: (resolve) =>
          require(['@/views/other/feedbackDetail'], resolve),
        name: 'FeedbackDetail',
        meta: { title: i18n.t('menu.feedback_detail') }
      },
      
    ]
  },
]

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const base =
  process.env.VUE_APP_PREFIX === 'tbbaccess'
    ? `/${process.env.VUE_APP_PREFIX}/`
    : '/'
export default new VueRouter({
  base,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
  scrollBehavior: () => {
    history.pushState(null, null, document.URL)
  }
})
